import script from "./LogisticsView.vue?vue&type=script&setup=true&lang=js"
export * from "./LogisticsView.vue?vue&type=script&setup=true&lang=js"

import "./LogisticsView.vue?vue&type=style&index=0&id=df5a0188&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df5a0188"]])

export default __exports__